/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// eslint-disable-next-line no-use-before-define
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
  Avatar,
  Dropdown,
  Menu as MenuAnt,
  MenuProps,
  Modal,
  Image as AntImage,
  Tooltip,
  Space,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { History } from 'history';
import { ApplicationState } from 'store/combineReducers';
import { config } from 'core/config';
import { axiosApi, baseUrlUser } from 'utils/api';
import uniqid from 'uniqid';
import { useTranslation } from 'react-i18next';
import getCurrentUser from 'routes/routes.service';
import profilePatch, { updateWebVersion } from 'pages/profile/profile.service';
import { changeUserLanguageTmp } from 'i18n';

import './styles.less';
import { WebVersionInfo } from 'core/models/userModel';
import { logoutUser } from 'pages/signIn';
import {
  DiffOutlined,
  DownOutlined,
  GlobalOutlined,
  KeyOutlined,
  RobotOutlined,
  LogoutOutlined,
  SecurityScanOutlined,
  UserOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';

const { Item } = MenuAnt;
const { profile, authentication, apikey, agentSettings } = config.paths;

const logoDefault = `/static/images/version-logo.jpeg`;

export default function AvatarDropdown(): ReactElement {
  const { t } = useTranslation();
  const [isVersionModalOpen, setIsVersionModalOpen] = useState(false);

  const { user } = useSelector((state: ApplicationState) => state.session);
  const { firstName, lastName, email } = user || {};
  const [versionInfo, setVersionInfo] = useState<any>();

  const dispatch = useDispatch();
  const history: History = useHistory();
  const handleLogout = useCallback(async (): Promise<void> => {
    await logoutUser();
  }, []);

  const handleAbout = useCallback(async (): Promise<void> => {
    if (user?.id != null) {
      setIsVersionModalOpen(true);
    }
  }, [dispatch, user, versionInfo]);

  const hangeLanguage = useCallback(
    async (e): Promise<void> => {
      changeUserLanguageTmp(e.key);
      // 更新用户语言信息
      const response = await profilePatch({ language: e.key });
      if (response) {
        await getCurrentUser();
        window.location.reload();
      }
    },
    [user],
  );

  const getVersionInfo = async () => {
    const res = await axiosApi().get(
      `${window.location.origin}/viva-ai-download/web/download_meta`,
    );
    if (res.status === 200) {
      setVersionInfo(res?.data?.web);
    }
  };

  useEffect(() => {
    getVersionInfo();
  }, []);

  const menuAntItems = [
    {
      label: t('layoutHeader.menuAntItems.profile'),
      onClick: () => {
        history.push(profile);
      },
      key: uniqid(),
      icon: <UserOutlined />,
    },
    // {
    //   label: t('layoutHeader.menuAntItems.authentication'),
    //   onClick: () => {
    //     history.push(authentication);
    //   },
    //   key: uniqid(),
    //   icon: <SecurityScanOutlined />,
    // },
    {
      label: t('layoutHeader.menuAntItems.language'),
      icon: <GlobalOutlined />,
      key: uniqid(),
      children: [
        {
          key: 'en-US',
          onClick: hangeLanguage,
          label: <div>English</div>,
        },
        {
          key: 'zh-CN',
          onClick: hangeLanguage,
          label: <div>简体中文</div>,
        },
      ],
    },
    {
      label: t('layoutHeader.menuAntItems.apikey'),
      onClick: () => {
        history.push(apikey);
      },
      key: uniqid(),
      icon: <KeyOutlined />,
    },
    // Only present when the clinic has MCP enabled. Spread into the array so the
    // entry is absent rather than disabled: an item that exists but refuses on
    // click advertises a feature the organization has not bought.
    ...(user?.tenant?.mcpEnabled
      ? [
          {
            label: t('layoutHeader.menuAntItems.agentSettings'),
            onClick: () => {
              history.push(agentSettings);
            },
            key: uniqid(),
            icon: <RobotOutlined />,
          },
        ]
      : []),
    {
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {t('layoutHeader.menuAntItems.about')}
        </div>
      ),
      onClick: handleAbout,
      icon: <DiffOutlined />,
      key: uniqid(),
    },
    {
      label: t('layoutHeader.menuAntItems.logout'),
      onClick: handleLogout,
      icon: (
        <LogoutOutlined
          style={{
            transform: 'rotate(180deg)',
            width: '12px',
            minWidth: '12px',
          }}
        />
      ),
      key: uniqid(),
    },
  ];

  const handleVersionCancel = useCallback(() => {
    setIsVersionModalOpen(false);
  }, []);

  const renderUpdateTime = () => {
    const temp = versionInfo?.timestamp || process.env.TIMESTAMP;
    if (Number(temp)) {
      const tempNum: number = Number(temp) || 0;
      return dayjs(tempNum * 1000).format('YYYY-MM-DD HH:mm:ss');
    }
    return '-';
  };

  return (
    <>
      <Dropdown
        trigger={['click']}
        menu={{ items: menuAntItems }}
        placement="bottomLeft"
        arrow
      >
        <div className="yahuikeji-profile">
          <div className="userName">
            <Space size={4}>
              <Avatar gap={8} style={{ background: 'var(--mainBg)' }}>
                {firstName?.[0] || email?.[0]}
                {lastName?.[0] || email?.[1]}
              </Avatar>
              <Tooltip
                title={`${firstName} ${lastName}`}
                placement="left"
                styles={{
                  body: {
                    wordWrap: 'unset',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                  },
                }}
              >
                <span style={{ fontWeight: 'bold' }}>
                  {`${firstName} ${lastName}`}
                </span>
              </Tooltip>
              <div className="arrow">
                <DownOutlined />
              </div>
            </Space>
          </div>
          {/* </Link> */}
        </div>
      </Dropdown>
      <Modal
        open={isVersionModalOpen}
        onCancel={handleVersionCancel}
        footer={null}
        className="version-info-modal"
        width={350}
      >
        <div className="version-info">
          <div
            className="logo"
            style={{
              filter:
                localStorage.getItem('vivalinkTheme') === 'dark'
                  ? 'invert()'
                  : 'invert(0%)',
            }}
          >
            <AntImage src={logoDefault} preview={false} />
          </div>
          <div className="v-u">
            <div className="version">
              <span className="label">Version:</span>
              <span>
                {versionInfo?.version || process.env.VERSION || 'v1.0.0'}
              </span>
            </div>
            <div className="update-time">
              <span className="label">Updated:</span>
              <span>{renderUpdateTime()}</span>
            </div>
          </div>
          <div className="copyright">
            Copyright © 2026 VivaLNK, Inc. All Rights Reserved.
          </div>
        </div>
      </Modal>
    </>
  );
}
